import { Plus } from "lucide-react";
import { CreateMassTortSlideover } from "@/components/features/mass-torts/CreateMassTortSlideover";
import { MassTortsTable } from "@/components/features/mass-torts/MassTortsTable";
import { AppPageShell, Button, Card, Text } from "@/components/ui";
import { useUser } from "@/components/UserProvider";
import {
  ACTION_PERMISSION_KEYS,
  ACTION_PERMISSION_VALUES,
} from "@/lib/data/static/permissionOptions";
import { useState } from "react";

export function MassTortsListView() {
  const { hasActionPermission } = useUser();
  const [isCreating, setIsCreating] = useState(false);

  const canCreate = hasActionPermission(
    ACTION_PERMISSION_KEYS.massTort,
    ACTION_PERMISSION_VALUES.create,
  );

  return (
    <AppPageShell className="h-full min-h-0 overflow-hidden">
      <Text as="h1" variant="title" className="mb-6 shrink-0">
        Mass torts
      </Text>
      <Card className="flex min-h-0 w-full flex-1 flex-col overflow-hidden p-6">
        <div
          data-testid="mass-torts-table-wrapper"
          className="flex min-h-0 flex-1 flex-col"
        >
          <MassTortsTable
            scrollableBody
            tableButtons={
              canCreate && (
                <Button
                  variant="foreground"
                  size="md"
                  className="shrink-0"
                  onClick={() => {
                    setIsCreating(true);
                  }}
                  data-testid="create-mass-tort-button"
                >
                  <Plus className="h-4 w-4" aria-hidden="true" />
                  Create mass tort
                </Button>
              )
            }
          />
        </div>
      </Card>

      <CreateMassTortSlideover open={isCreating} setOpen={setIsCreating} />
    </AppPageShell>
  );
}
